module.exports = __webpack_public_path__ + "static/media/follow_food_elvis2.eb90e253.jpg";